import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';

import {
  parentOrganizationsModule,
  loadParentOrg,
  clearState
} from './ParentOrganizationsDucks';
import StaticTablePagination from '../../../_ui/Table/StaticTablePaginated';
import useTableFilter from '../../../components/TableFilter/useTableFilter';
import TableFilterProvider from '../../../components/TableFilter/TableFilterProvider';
import {parentOrganizationsColumns} from "./ParentOrganizationsColumns";

const ParentOrganizationsTable = ({ index, tableData, loadParentOrg, loading, clearState, ...rest }) => {
  const { t, i18n } = useTranslation();
  const filter = useTableFilter(loadParentOrg, index);
  useEffect(() => clearState, [clearState]);

  return (
    <TableFilterProvider index={filter.index}>
      <StaticTablePagination
        loading={loading}
        columns={parentOrganizationsColumns(t, i18n.language)}
        data={tableData.content}
        totalElements={tableData.totalElements}
        onClickLoadMore={filter.nextPage}
        {...rest}
      />
    </TableFilterProvider>
  );
};

export default connect(
  state => ({
    loading: state[parentOrganizationsModule].loading,
    tableData: state[parentOrganizationsModule].tableData
  }),
  {
    loadParentOrg,
    clearState
  }
)(ParentOrganizationsTable);
